import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import { BusyService } from '../../_services/busy.service';
import { CommonModule, DatePipe } from '@angular/common';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

@Component({
  selector: 'app-patent-subcategory',
  standalone: true,
  imports: [RouterLink, DatePipe, CommonModule, SidebarComponent],
  templateUrl: './patent-subcategory.component.html',
  styleUrl: './patent-subcategory.component.scss',
})
export class PatentSubcategoryComponent {
  filePath = 'https://adminbackend.chemrobotics.com/uploads/news_images/';
  subcategoryId!: string;
  subcatNews: any[] = [];
  loading = false;
  subCategoryName: any = [];
  heading = '';
  toggle_sidebar = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private datasearch: DatasearchService,
    private busyService: BusyService,
    private cdref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // Get ID from URL
    this.route.paramMap.subscribe((params) => {
      this.subcategoryId = params.get('id') || '';
      console.log("subcategory id :", this.subcategoryId);

      if (this.subcategoryId) {
        this.fetchSubcategoryNews();
      }
    });
  }

  fetchSubcategoryNews() {
    this.loading = true;
    this.datasearch.getNewsBySubcategory(this.subcategoryId).subscribe(
      (res) => {
        this.loading = false;
        this.subCategoryName = res.data.subcategory;
        console.log('Subcategory name:', this.subCategoryName);
        this.subcatNews = res.data.news; // depends on your backend response structure
        console.log('Subcategory news:', this.subcatNews);
      },
      (err: any) => {
        this.loading = false;
        console.error('Failed to fetch subcategory news', err);
      }
    );
  }


  goToNewsDetail(_id: any) {
    this.router.navigate(['/discovery-updates', _id]);
  }

  goBackTocategories(): void {
    this.router.navigate(['/discovery']);
  }

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }

  receiveHeading(event: string) {
    this.heading = event;
    this.cdref.detectChanges();
  }

  receiveSidebarEvent(event: boolean) {
    this.toggle_sidebar = event;
    this.cdref.detectChanges();
  }
}
